import { Link, useLocation } from "react-router";
import { buttonVariants } from "@/components/ui/Button";

/**
 * 404 als eigenstaendige Seite — der Catch-all liegt hier ausserhalb von
 * AuthGuard und AppShell, die Seite muss sich also selbst tragen.
 *
 * Ersetzt den frueheren stillen `<Navigate to="/">` des Catch-all: der
 * Redirect verschluckte Tippfehler und tote Links kommentarlos und warf
 * den Nutzer ohne Erklaerung auf die Startseite zurueck.
 *
 * Die aufgerufene Adresse wird mit angezeigt — bei einem vertippten oder
 * abgeschnittenen Link ist das der schnellste Hinweis. React escaped den Wert;
 * er steht ohnehin schon in der Adresszeile.
 */
export default function NotFound() {
    const { pathname } = useLocation();

    return (
        <main
            className="flex min-h-screen flex-col items-center justify-center gap-8 px-5 py-12 text-center"
            style={{ backgroundColor: "var(--surface-canvas)" }}
        >
            <img
                src="/page-not-found.svg"
                alt=""
                width={280}
                height={222}
                /* Die Illustration ist fuer helle Flaechen gezeichnet und wirkt
                   auf dem dunklen Canvas sonst wie ein weisser Block. */
                className="h-auto w-[min(280px,70vw)] dark:opacity-75"
            />

            <div>
                <p className="text-xs font-medium uppercase tracking-[0.12em] text-neutral-500 dark:text-neutral-400">
                    Fehler 404
                </p>
                <h1 className="mt-3 text-3xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
                    Diese Seite gibt es nicht.
                </h1>
                <p className="mx-auto mt-3 max-w-[46ch] text-sm text-neutral-600 dark:text-neutral-300">
                    Vielleicht ist der Link veraltet oder die Adresse enthält einen Tippfehler.
                </p>
                <p className="mt-4">
                    <code className="inline-block max-w-full break-all rounded-lg bg-neutral-100 px-2.5 py-1.5 font-mono text-xs text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
                        {pathname}
                    </code>
                </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3">
                <Link to="/" className={buttonVariants({ variant: "primary" })}>
                    Zur Startseite
                </Link>
                <button
                    type="button"
                    onClick={() => window.history.back()}
                    className={buttonVariants({ variant: "outline" })}
                >
                    Zurück
                </button>
            </div>
        </main>
    );
}
